import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import Carrier from '../Carrier'
import Note from './Note'
import Contact from './EnquiryContact'
import Consignment from '../Consignment'
import Ldap from '../User/Ldap'
import Account from '../Account'

export default class extends Resource {
  static name = 'enquiry'

  static get fields () {
    return {
      id: new UUID(),
      con_full: new STRING(),
      enq_origin: new STRING(),
      enq_status: new STRING(),
      enq_pri: new STRING(),
      enq_date: new STRING(),
      enq_carrier_ref: new STRING(),
      carrier: new ITEM(Carrier),
      enquiry_notes: new COLLECTION(Note),
      consignment: new ITEM(Consignment),
      user: new ITEM(Ldap),
      account: new ITEM(Account),
      contact: new ITEM(Contact),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
